/// <reference types="vite/client" />

declare const PACKAGE_VERSION: string;
// надо в прокси вытащить
export const mediaUrl: string = "https://swagger.baskit.ru/storage";
